<style src="./style.scss">
</style>

<script lang="ts">
  const currentYear = new Date().getFullYear();
</script>

<div class="footer">Copyright © {currentYear} CNA Go ®</div>
